import React, { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import Slider from "react-slick";
import img02 from "./images/beetel-leadline.webp";
import { Accordion, AccordionItem } from "react-light-accordion";
import axios from "axios";
import { Link } from "react-scroll";

export const Leadline = () => {
  var decodeHTML = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function createMarkup(content) {
    return { __html: decodeHTML(content) };
  }

  const [pagedata, setPagedata] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(window.weburl + `api/plans.php?catID=7`);
      if (mounted) {
        setPagedata(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  console.log(pagedata);
  if (pagedata.length === 0) {
    console.log("no data");
    // return null;
  }

  const [user_mobile, setusermobile] = useState();
  const [plans, setPlans] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const ref_mobile = useRef(null);

  const [selectedPlan, setSelectedPlan] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_plans.php?cid=12")
      .then((response) => setPlans(response.data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => setStates(response.data))
      .catch((error) => console.log(error));
  }, []);

  function getCities(state) {
    axios
      .get(window.weburl + `api/get_cities.php?sid=${state}`)
      .then((response) => setCities(response.data))
      .catch((error) => console.log(error));
  }

  const handledisable = () => {
    if (isValidPhone(user_mobile) && user_mobile) {
      const element = document.getElementById("submit_button_text");
      element.classList.remove("disabled");
      setIsDisabled(false);
    } else {
      const element = document.getElementById("submit_button_text");
      element.classList.add("disabled");
      setIsDisabled(true);
    }
  };

  function isValidPhone(phone) {
    const regex = /^[6-9]\d{9}$/gi;
    return regex.test(phone);
  }

  const handleSubmit = () => {
    if (!isValidPhone(user_mobile)) {
      alert("Please enter Mobile number");
      ref_mobile.current.focus();
      return false;
    } else {
      const url = window.weburl + "api/insert_hook.php";
      let fData = new FormData();
      fData.append("user_mobile", user_mobile);
      fData.append("catid", "7");
      fData.append("pid", selectedPlan);
      fData.append("user_state", selectedState);
      fData.append("user_city", selectedCity);
      fData.append("td_name", "androidtv");
      fData.append("utm_url", window.location.href);
      axios
        .post(url, fData)
        .then((response) => {
          // ⭐⭐⭐ ADD GOOGLE ADS CONVERSION TAG HERE
          if (window.gtag) {
            window.gtag("event", "conversion", {
              // send_to: "AW-801924308/pEhpCICE9_4CENTJsf4C",
              send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C",
            });
          }
          // ⭐⭐⭐ END TAG

          alert(response.data);
        })
        .catch((error) => alert(error));
      window.location.reload();
    }
  };

  var settings = {
    dots: true,
    navigation: true,
    loop: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    speed: 300,
    autoplaySpeed: 5000,
    arrows: false,
    cssEase: "linear",
  };
  return (
    <>
      <Header />
      <section
        id="banner"
        className="p-0"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-duration="600"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div className="banner mngslide">
          <div className="container">
            <div className="row">
              <Slider {...settings}>
                <div>
                  <div className="sliderrow">
                    <div className="slideimg">
                      <img src={img02} alt="Banner Netplus" />
                    </div>
                    <div className="slidecont">
                      <div className="circle01">
                        <div className="mngcircle">
                          <div className="circlimg circlimg222">
                            <h2>Netplus Bonanza </h2>
                          </div>
                          <div className="listpoint">
                            <p>Get leadline phone at very attractive price!</p>
                            <ul>
                              <li>Caller ID Phone with speaker Phone</li>
                              <li>Two way Speaker caller ID</li>
                              <li>+16 Digit LCD Display</li>
                              <li>VIP Number Storage</li>
                              <li>
                                Starting At Just{" "}
                                <strong
                                  style={{
                                    borderBottom: "2px solid #fff",
                                    paddingBottom: "2px",
                                    fontSize: "17px", // 🔽 reduce size
                                    fontWeight: "500", // 🔽 lighter than bold
                                    lineHeight: "normal",
                                  }}
                                >
                                  <i className="finr"></i>895/-
                                </strong>
                              </li>
                            </ul>
                          </div>
                          {/* <div className='booknow'>
                                                        <Link
                                                            to="contactus"
                                                            smooth={true}
                                                            duration={50}
                                                            offset={-40}
                                                        >
                                                            BOOK NOW
                                                        </Link>
                                                    </div> */}
                        </div>
                      </div>
                      <div className="circle02"></div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section id="filter">
        <div className="filter">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="footerform"
                  data-aos="fade-up"
                  data-aos-offset="10"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <div className="heading">
                    <h4>Get it today</h4>
                  </div>
                  <div className="form">
                    <form>
                      <ul>
                        <li>
                          <input
                            type="text"
                            name="user_mobile"
                            id="user_mobile"
                            placeholder="Mobile number*"
                            pattern="[a-zA-Z\s]+"
                            value={user_mobile}
                            onChange={(e) => {
                              setusermobile(e.target.value);
                            }}
                            onKeyUp={handledisable}
                            ref={ref_mobile}
                          />
                        </li>
                        <li>
                          <select
                            name="selectedPlan"
                            id="selectedPlan"
                            value={selectedPlan}
                            onChange={(event) => {
                              setSelectedPlan(event.target.value);
                            }}
                          >
                            <option value="">Select Product</option>
                            {plans.map((plan) => (
                              <option
                                key={plan.sno}
                                value={plan.sno}
                                dangerouslySetInnerHTML={createMarkup(
                                  plan.pname + " " + plan.ptitle,
                                )}
                              ></option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            name="selectedState"
                            id="selectedState"
                            value={selectedState}
                            onChange={(event) => {
                              setSelectedState(event.target.value);
                              getCities(event.target.value);
                            }}
                          >
                            <option value="">Select Region</option>
                            {states.map((state) => (
                              <option key={state.stateid} value={state.stateid}>
                                {state.sname}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            name="selectedCity"
                            id="selectedCity"
                            value={selectedCity}
                            onChange={(event) =>
                              setSelectedCity(event.target.value)
                            }
                          >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                              <option key={city.cityid} value={city.cityid}>
                                {city.cityname}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li className="buttnprop">
                          <input
                            type="submit"
                            value=""
                            id="submit_button"
                            disabled={isDisabled}
                            onClick={handleSubmit}
                          />
                          <span id="submit_button_text" className="disabled">
                            SUBMIT
                          </span>
                        </li>
                      </ul>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="enterprise">
        <div className="enterprise">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <span>Landline Phone</span>
                  <h3>Beetel M500 Corded Landline</h3>
                  <h4>Caller ID Phone with speaker Phone</h4>
                </div>
                <div
                  className="smartcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <p>
                    Beetel M500 caller ID speakerphone is highly durable and
                    compatible with all landline, broadband and fibre
                    connections. One year service warranty is applicable on
                    Fixed Line Handset.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="specification">
        <div className="specification">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="heading"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h4>Product Specifications</h4>
                </div>
                <div
                  className="faqcont"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                        <td> Brand</td>
                        <td> Beetel</td>
                      </tr>
                      <tr>
                        <td> Type</td>
                        <td>Corded Landline Phone</td>
                      </tr>
                      <tr>
                        <td> Model Name</td>
                        <td> M500</td>
                      </tr>
                      <tr>
                        <td>Colour</td>
                        <td>Black</td>
                      </tr>
                      <tr>
                        <td>Features</td>
                        <td>
                          Toggle Mute, 16 Digit LCD Display, VIP Number Storage,
                          FSK/DTMF Compatible Caller-ID, 6-Step LCD
                        </td>
                      </tr>
                      <tr>
                        <td>Dedicated Buttons </td>
                        <td>
                          Set, Up, Down, Del. Out, Mute, Pause, Flash, Redial
                        </td>
                      </tr>
                      <tr>
                        <td> Wall Mountable</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td> Conference Call</td>
                        <td> Yes</td>
                      </tr>
                      <tr>
                        <td> Call Log </td>
                        <td> 50</td>
                      </tr>
                      <tr>
                        <td> Caller ID </td>
                        <td> Yes</td>
                      </tr>
                      <tr>
                        <td> Call Transfer</td>
                        <td> Yes</td>
                      </tr>
                      <tr>
                        <td> Speaker Phone</td>
                        <td> Yes</td>
                      </tr>
                      <tr>
                        <td> Number of Ringtones </td>
                        <td> 1</td>
                      </tr>
                      <tr>
                        <td> Display Type </td>
                        <td> LCD Display </td>
                      </tr>

                      <tr>
                        <td> Number of Display Lines </td>
                        <td> 1 </td>
                      </tr>

                      <tr>
                        <td> Outgoing Redial Memory </td>
                        <td> 5 </td>
                      </tr>

                      <tr>
                        <td> Phone Book </td>
                        <td> No </td>
                      </tr>

                      <tr>
                        <td> Base Unit Power Source </td>
                        <td> 2 AA Battery (not provided with the set) </td>
                      </tr>

                      <tr>
                        <td> Box Contents </td>
                        <td>
                          {" "}
                          1 Base Unit, 1 Receiver , 1 Line Cord , 1 Receiver
                          Cord , 1 User Manual{" "}
                        </td>
                      </tr>

                      <tr>
                        <td> Warranty</td>
                        <td>
                          {" "}
                          The warranty covers a 1-year from the date of
                          purchase.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Contactform /> */}
      <Footer />
    </>
  );
};
